/* The file contents for the current environment will overwrite these during build.
   The build system defaults to the dev environment which uses `environment.ts`, but if you do
   `ng build --env=prod` then `environment.prod.ts` will be used instead.
   The list of which env maps to which file can be found in `.angular-cli.json`. */

import { sceconfig } from "sce-core";

declare const window: any;

const feedbackDisplayId = window['env']['feedbackDisplayId'] || '1234175055437234176';

export const environment = {
  production: true,
  logger: "console",

  baseUrlUI: sceconfig.wms.baseUrlUI,
  wmsApiBaseUrl: window["env"]["wmsApiBaseUrl"] || "http://localhost:8080/lfcoreservice/",
  commonApiBaseUrl : window["env"]["commonApiBaseUrl"] || "http://localhost:8080/scecommon/",
  growthbookClientKey: 'GROWTHBOOK_CLIENT_KEY_PLACEHOLDER',
  iamClientId: 'IAM_CLIENT_ID_PLACEHOLDER',
  growthbookHostApi: window["env"]["growthbookHostApi"] || 'https://growthbook-proxy.fbm.maersk.com/',
  anchorFeedbackFormBaseUrl : window['env']['anchorFeedbackBaseUrl'] || 'https://insightshub-api.maersk-digital.net/api/feedbacks/',
  feedbackFormId: window['env']['feedbackFormId'] || 'e0eb3a77-1dd3-474c-99b1-a299121d32b2',
  susFeedbackFormId: window['env']['susFeedbackFormId'] || 'c3f7f59f-831d-455c-ab71-2dca2a6ce71d',
  anchorFeedbackURL: window['env']['anchorFeedbackURL'] || 'https://insightshub.maersk-digital.net/embed/embed.js',
  feedbackDisplayId,
  feedbackEmailURL: window['env']['feedbackEmailURL'] || `https://insightshub-api.maersk-digital.net/api/feedbacks/${feedbackDisplayId}/author/`,
  ptwClientUrl: window['env']['ptwClientUrl'] || 'https://cdt-fbm-ptw-client.maersk-digital.net/',
  toriAppId: window['env']['toriAppId'] || 'A21058',
  toriPlatformId: window['env']['toriPlatformId'] || 'PLA012',
  toriTitle: window['env']['toriTitle'] || 'MWMS Assistant',
  toriPrompts: window['env']['toriPrompts'] || '["How can I request for Maersk WMS v2 access?","How can I raise a support ticket for an incident relating to Maersk WMS v2?","How many environments does the Maersk WMS v2 have?"]',
};



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/environments/environment.ts